






























import { defineComponent } from "@vue/composition-api";
import BaseInputFile from "@/components/BaseInputFile";
import DragDropFiles from "@/components/DragDropFiles";

export default defineComponent({
  name: "BaseDropZone",
  components: { BaseInputFile, DragDropFiles },
  props: {
    multiple: { type: Boolean },
    allowedFileTypes: { type: Array as () => string[], required: true },
    showDropZone: { type: Boolean, required: true },
  },
});
